/* eslint-disable prefer-destructuring */
import React from 'react';
import { connect } from 'react-redux';
import Pagination from '@mui/material/Pagination';
import MenuItem from '@mui/material/MenuItem';
import { IAppState } from '../../../../state/reducers';
import {
  IProps,
  IStateProps,
  IDispatchProps,
} from './interfaces';
import {
  PaginationContainer, PageStatusContainer, PageSizeContainer, PageSizeSelect,
} from './styles';
import { updateSearchQueryParams, queryGamesAction } from '../../../../state/search';
import Info from '../Info/component';

const SearchPagination: React.FunctionComponent<IProps> = (props: IProps) => {
  const {
    search: {
      queryParams: {
        size,
        page,
      },
      searchResponse,
    },
    updateSearchQueryParamsConnect,
    queryGamesActionConnect,
  } = props;

  if (searchResponse === null) {
    return null;
  }

  const { hits: { total: { value: total } } } = searchResponse;

  if (total === 0) {
    return null;
  }

  // It appears there is a restriction in ElasticSearch (maximum value of from + size must be less than 10000),
  // so we restrict the number of pages
  const maxResult = 10000;
  const assetsCount = total > maxResult ? maxResult : total;
  const pagesCount = total > maxResult ? Math.max(Math.floor(assetsCount / size), 1) : Math.ceil(assetsCount / size);

  const handleChange = (e: any, value: number) => {
    updateSearchQueryParamsConnect({
      page: value,
    });
    queryGamesActionConnect();
  };

  const handlePageSizeChange = (e: any) => {
    updateSearchQueryParamsConnect({
      size: e.target.value,
      page: 1,
    });
    queryGamesActionConnect();
  };

  const { search } = props;

  return (
    <PageStatusContainer>
      <PageSizeContainer>
        <Info {...search} />
        <span>Rows per page:</span>
        <PageSizeSelect
          value={size}
          onChange={handlePageSizeChange}
          size="small"
          variant="outlined"
        >
          {[10, 25, 50, 100].map((opt) => (
            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
          ))}
        </PageSizeSelect>
      </PageSizeContainer>
      <PaginationContainer>
        <Pagination
          count={pagesCount}
          page={page}
          onChange={handleChange}
          siblingCount={4}
          color="primary"
        />
      </PaginationContainer>
    </PageStatusContainer>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  search: state.search,
});

const mapDispatchToProps: IDispatchProps = {
  updateSearchQueryParamsConnect: updateSearchQueryParams,
  queryGamesActionConnect: queryGamesAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchPagination);
